import { postRequest } from '../helpers/request';

export async function apiReadAllYoutubeVideos(options) {
  return postRequest('/videos/api/get_all_videos/', options);
}

export async function apiReadAllVideoCategories(options) {
  return postRequest('/videos/api/get_all_video_categories/', options);
}

export async function apiToggleFavourite(options) {
  return postRequest('/videos/api/toggle_favourite/', options);
}

export async function apiMarkVideoAsWatched(options) {
  return postRequest('/videos/api/toggle_watched/', options);
}

export async function apiReadAllFavourites(options) {
  return postRequest('/videos/api/get_favourited_videos_by_user/', options);
}

export async function apiReadSingularVideo(options) {
  return postRequest('/videos/api/get_video_from_video_id/', options);
}

export async function apiHandleVideoMetric(options) {
  return postRequest('/videos/api/handle_video_metric/', options);
}

/**
 * Fetches webinars eligible for the dashboard banner:
 * LIVE, SCHEDULED, and recently ENDED webinars.
 * @returns {Promise<{results: Array}>}
 */
export async function apiGetDashboardWebinars() {
  return postRequest('/dashboard/webinars/');
}

// ── Wistia utilities ──────────────────────────────────────────────────────────

/**
 * Extract the swatch thumbnail URL from the CSS url() inside a Wistia embed string.
 * @param {string|null} embedHtml
 * @returns {string|null}
 */
export function extractWistiaSwatchUrl(embedHtml) {
  if (!embedHtml) return null;
  const match = embedHtml.match(/url\(['"]?(https?:\/\/[^'")\s]+)['"]?\)/);
  return match ? match[1] : null;
}

export function extractWistiaMediaId(embedHtml) {
  if (!embedHtml) return null;
  const playerMatch = embedHtml.match(/<wistia-player\b[^>]*\smedia-id=["']([^"']+)["']/);
  if (playerMatch) return playerMatch[1];
  const urlMatch = embedHtml.match(/fast\.wistia\.com\/embed\/([a-zA-Z0-9]+)\.js/);
  return urlMatch ? urlMatch[1] : null;
}

// ── Webinar Chat API ───────────────────────────────────────────────────────────

export async function apiGetChatMessages(payload) {
  return postRequest('/marketing_module/webinars/chat/get_messages/', payload);
}

export async function apiSendChatMessage(payload) {
  return postRequest('/marketing_module/webinars/chat/send_message/', payload);
}

export async function apiGetPolls(payload) {
  return postRequest('/marketing_module/webinars/polls/get_polls/', payload);
}

export async function apiCreatePoll(payload) {
  return postRequest('/marketing_module/webinars/polls/create_poll/', payload);
}

export async function apiClosePoll(payload) {
  return postRequest('/marketing_module/webinars/polls/close_poll/', payload);
}

export async function apiRespondToPoll(payload) {
  return postRequest('/marketing_module/webinars/polls/respond/', payload);
}

export async function apiGetPollResults(payload) {
  return postRequest('/marketing_module/webinars/polls/results/', payload);
}

export async function apiLogWebinarAttendance(payload) {
  return postRequest('/marketing_module/webinars/attendance/log/', payload);
}

export async function apiLogWebinarEvent(payload) {
  return postRequest('/marketing_module/webinars/events/log/', payload);
}

export async function apiGetWebinarEventStats(payload) {
  return postRequest('/marketing_module/webinars/events/stats/', payload);
}

// ── Webinar Registration API ──────────────────────────────────────────────────

export async function apiRegisterForWebinar(payload) {
  return postRequest('/marketing_module/webinars/register/', payload);
}

export async function apiCheckWebinarRegistration(payload) {
  return postRequest('/marketing_module/webinars/check_registration/', payload);
}

export async function apiGetUpcomingWebinar() {
  return postRequest('/webinar-registration/api/get_upcoming/');
}

export async function apiPublicWebinarRegister(payload) {
  return postRequest('/webinar-registration/api/register/', payload);
}

export async function apiGetWebinarReport(payload) {
  return postRequest('/marketing_module/webinars/report/', payload);
}
